import GavelIcon from "@mui/icons-material/Gavel";
import { Button, SelectInput, required, useNotify, useRecordContext } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { doctoralRequests } from "api/doctoralApi";
import { DoctorantDefenseResultChoices } from "utils/choices";

const RecordDefenseResultControl = ({ onSaved }) => {
  const record = useRecordContext();
  const notify = useNotify();

  if (!record?.id) return null;

  const handleConfirm = async data => {
    await dataProvider.customRequest(
      doctoralRequests.recordDoctorantDefenseResult(record.id),
      { result: data.result },
      "PUT",
    );
    notify("Резултатът от защитата е записан", { type: "success" });
    onSaved?.();
  };

  return (
    <FormModal
      titleContent="Резултат от защитата"
      saveTitle="Запази"
      onConfirm={handleConfirm}
      triggerButton={
        <Button
          label="Въведи резултат"
          variant="contained"
          startIcon={<GavelIcon />}
        />
      }
    >
      <SelectInput
        source="result"
        label="Резултат"
        choices={DoctorantDefenseResultChoices}
        validate={required("Задължително")}
        fullWidth
      />
    </FormModal>
  );
};

export default RecordDefenseResultControl;
